module.exports = __webpack_public_path__ + "media/cool_chestnut_montage.69400a66.mp4";